import React, { useRef, useState, useEffect } from "react";
import { push, useHistory, useParams, useLocation } from "react-router-dom";
import queryString from "query-string";
import axios from "axios";
import {
  FormikForm,
  Section,
  AgGridDataTable,
  TonnageDisclaimer,
  Breadcrumbs,
} from "../../../shared";
import * as yup from "yup";
import ProgressComponenet from "../../../shared/utilities/ProgressComponent";
import urlParameterHelper from "../../../../utilities/urlParameters";

const date = new Date();

export default function EntitiesWhichInterfaceReport(props) {

  // summ report
  const [reportProgressPercentage, setReportProgressPercentage] = useState(0);
  const [reportProgressPercentage2, setReportProgressPercentage2] = useState(0);
  const [reportIsLoading, setReportIsLoading] = useState(false);
  const [reportValue, setReportValue] = useState(
    Math.round(Math.random() * (44 - 20)) + 20
  );
  const [reportStop, setReportStop] = useState(false);

  const formRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const [hasSubmitted1, setHasSubmitted1] = useState(false);

  const [initialFormValues, setInitialFormValues] = useState({
    epaId: params && params.epaId ? params.epaId : "",
    siteType: params && params.siteType ? params.siteType : "",
    fromDate: params && params.fromDate ? params.fromDate : "",
    toDate: params && params.toDate ? params.toDate : "",
    shipYear: params && params.shipYear ? params.shipYear : "",
    multiInterfaceType: params && params.InterfaceType ? params.InterfaceType : "",
  });
  const agGridRef0 = useRef();
  const [rowData0, setRowData0] = useState([]);
  const [api0IsFetching, setapi0IsFetching] = useState(false);
  const [columnDefs0, setColumnDefs0] = useState([
    {
      headerName: "",
      field: "",
    },
  ]);
  const agGridRef1 = useRef();
  const [formParams, setFormParams] = useState([]);
  const [rowData1, setRowData1] = useState([]);
  const [api1IsFetching, setapi1IsFetching] = useState(false);
  const [columnDefs1, setColumnDefs1] = useState([
    {
      headerName: "",
      field: "",
    },
  ]);
  const agGridRef2 = useRef();
  const [rowData2, setRowData2] = useState([]);
  const [api2IsFetching, setapi2IsFetching] = useState(false);
  const [columnDefs2, setColumnDefs2] = useState([
    {
      headerName: "",
      field: "",
    },
  ]);
  const agGridRef3 = useRef();
  const [rowData3, setRowData3] = useState([]);
  const [columnDefs3, setColumnDefs3] = useState([
    {
      headerName: "",
      field: "",
    },
  ]);
  const agGridRef4 = useRef();
  const [rowData4, setRowData4] = useState([]);
  const [columnDefs4, setColumnDefs4] = useState([
    {
      headerName: "",
      field: "",
    },
  ]);
  const agGridRef5 = useRef();
  const [rowData5, setRowData5] = useState([]);
  const [columnDefs5, setColumnDefs5] = useState([
    {
      headerName: "",
      field: "",
    },
  ]);

  const backToUrl = "/reports";
  const pageTitle = "Intities Which Interface";
  const apiEndpoint0 = "/api/v1/hwts/search/entity/interfacesumm";
  const apiEndpoint1 = "/api/v1/hwts/search/entity/interface";
  const apiEndpoint2 = "/api/v1/hwts/search/entity/interfaceCsv";
  const [source, setSource] = useState(axios.CancelToken.source());
  history.listen(() => {
    cancelCall();
  });
  const cancelCall = () => {
    source.cancel();
    setSource(axios.CancelToken.source());
  };

  const schema = yup.object().shape(
    {
      epaId: yup
        .string().required("ID Number is required.").min(12, "ID Number requires a min length of 12."),
      siteType: yup.string().required("Handler Type is required."),
      multiInterfaceType: yup.string().required("Interface Type is required."),
      toDate: yup.string(),
      fromDate: yup.string().when(["shipYear"], {
        is: (shipYear) => !shipYear,
        then: yup.string().required("Either Shipment Dates or Ship Year is required."),
      }),
      shipYear: yup.string().when(["fromDate"], {
        is: (fromDate) => !fromDate,
        then: yup.string().required("Either Shipment Dates or Ship Year is required."),
      }),
    },
    [
      ["fromDate", "shipYear"],
      ["shipYear", "fromDate"],
    ]
  );

  const formConfig = [
    {
      name: "epaId",
      config: {
        col: "md",
        colWidth: "2",
        label: "Source ID Number",
        type: "text",
      },
    },
    {
      name: "siteType",
      config: {
        col: "md",
        colWidth: "2",
        label: "Handler Type",
        placeholder: "Select a Site Type",
        type: "select",
        data: [
          { label: "Generator", value: "Generator" },
          { label: "Transporter", value: "Transporter" },
          { label: "Transporter 2", value: "Transporter2" },
          { label: "TSDF", value: "TSDF" },
          { label: "ALT. TSDF", value: "ALT TSDF" },
        ],
      },
    },
    {
      name: "multiInterfaceType",
      config: {
        col: "md",
        colWidth: "2",
        label: "Interface Type",
        info: "Specify the entity type of the Interfaced ID Number.",
        placeholder: "Select a Interface Type",
        type: "multi-select",
        data: [
          { label: "Generator", value: "generator" },
          { label: "Transporter", value: "transporter" },
          { label: "TSDF", value: "tsdf,DesignatedFacility" },
          { label: "ALT. TSDF", value: "ALT TSDF" },
        ],
      },
    },
    {
      name: "shipYear",
      config: {
        col: "md",
        validate: true,
        colWidth: "2",
        label: "Ship Year",
        placeholder: "Select a Year",
        type: "year",
      },
    },
    {
      name: "fromDate",
      config: {
        col: "md",
        colWidth: "2",
        label: "Ship From Date",
        placeholder: "",
        type: "date",
      },
    },
    {
      name: "toDate",
      config: {
        col: "md",
        colWidth: "2",
        label: "Ship To Date",
        placeholder: "",
        type: "date",
      },
    },
  ];

  const customGridCells = [
    {
      columnName: "Interface_ID",
      cellRenderer: function (params) {   
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "Manifests",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/reports/manifest?epaId=${params.data.Source_ID_Number}&entityType=${formRef.current.values.siteType}&fromDate=${formRef.current.values.fromDate}&toDate=${formRef.current.values.toDate}&shipYear=${formRef.current.values.shipYear}&interfaceId=${params.data.Interface_ID}&interfaceType=${params.data.Interface_Entity_Type}&transporterOrder=${params.data.Order}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
  ];
  const setAgGrid0 = (data) => {
    let columnsArr = data[0];
    let colDefArr = [];

    let colDef = Object.keys(columnsArr).map((col) => {
      colDefArr.push({
        headerName: col.replace(/_/g, " "),
        field: col,
        sortable: true,
        filter: col.includes("Interface") ? true : false,
        hide: (col.includes("fac_") || col.includes("contact_")) ? true : false,
      });
    });

    setColumnDefs0(colDefArr);
    setRowData0(data);
  };

  const setAgGrid1 = (data) => {
    let columnsArr = data[0];
    let colDefArr = [];
    let filterData = data.filter(data => data.Interface_Entity_Type === 'GENERATOR');

    let colDef = Object.keys(columnsArr).map((col) => {
      if (customGridCells) {
        var cellRend = customGridCells.filter(
          (object) => object.columnName === col
        );
        if (cellRend.length > 0) {
          colDefArr.push({
            headerName: col.replace(/_/g, " "),
            field: col,
            maxWidth: col.includes("Interface_ID") ? 135 : "",
            sortable: true,
            cellRenderer: cellRend[0].cellRenderer,
            hide: (col.includes("Source_ID_Number") || col.includes("Entity_Type") || col.includes("Order")) ? true : false,
          });
        } else {
          colDefArr.push({
            headerName: col.replace(/_/g, " "),
            field: col,
            maxWidth: col.includes("Total_Tons") ? 105 : "",
            minWidth: col.includes("Interface_Name") ? 40 : col.includes("Interface_County") ? 12 : col.includes("Manifests") ? 20 : "",
            sortable: true,
            hide: (col.includes("Source_ID_Number") || col.includes("Entity_Type") || col.includes("Order")) ? true : false,
          });
        }
      }
    });

    setColumnDefs1(colDefArr);
    setRowData1(filterData);
  };

  const setAgGrid2 = (data) => {
    let columnsArr = data[0];
    let colDefArr = [];
    let filterData = data.filter(data => data.Interface_Entity_Type === 'TRANSPORTER');

    let colDef = Object.keys(columnsArr).map((col) => {
      if (customGridCells) {
        var cellRend = customGridCells.filter(
          (object) => object.columnName === col
        );
        if (cellRend.length > 0) {
          colDefArr.push({
            headerName: col.replace(/_/g, " "),
            field: col,
            maxWidth: col.includes("Interface_ID") ? 135 : "",
            sortable: true,
            cellRenderer: cellRend[0].cellRenderer,
            hide: (col.includes("Source_ID_Number") || col.includes("Entity_Type")) ? true : false,
          });
        } else {
          colDefArr.push({
            headerName: col.replace(/_/g, " "),
            maxWidth: col.includes("Total_Tons") ? 120 : col.includes("Order") ? 120 : "",
            minWidth: col.includes("Interface_Name") ? 36 : col.includes("Interface_County") ? 12 : col.includes("Manifests") ? 22 : "",
            field: col,
            headerTooltip: col.includes("Order") ? "The order the transporter appeared on a manifest, i.e., Transporter 1, Transporter 2." :"",
            tooltipComponentParams: { color: 'white' },
            sortable: true,
            filter: col.includes("Order") ? true : false,
            hide: (col.includes("Source_ID_Number") || col.includes("Entity_Type")) ? true : false,
          });
        }
      }
    });
    setColumnDefs2(colDefArr);
    setRowData2(filterData);
  };

  const setAgGrid3 = (data) => {
    let columnsArr = data[0];
    let colDefArr = [];
    let filterData = data.filter(data => data.Interface_Entity_Type === 'TSDF');

    let colDef = Object.keys(columnsArr).map((col) => {
      if (customGridCells) {
        var cellRend = customGridCells.filter(
          (object) => object.columnName === col
        );
        if (cellRend.length > 0) {
          colDefArr.push({
            headerName: col.replace(/_/g, " "),
            field: col,
            maxWidth: col.includes("Interface_ID") ? 135 : "",
            sortable: true,
            cellRenderer: cellRend[0].cellRenderer,
            hide: (col.includes("Source_ID_Number") || col.includes("Entity_Type") || col.includes("Order")) ? true : false,
          });
        } else {
          colDefArr.push({
            headerName: col.replace(/_/g, " "),
            field: col,
            maxWidth: col.includes("Total_Tons") ? 105 : "",
            minWidth: col.includes("Interface_Name") ? 40 : col.includes("Interface_County") ? 12 : col.includes("Manifests") ? 20 : "",
            sortable: true,
            hide: (col.includes("Source_ID_Number") || col.includes("Entity_Type") || col.includes("Order")) ? true : false,
          });
        }
      }
    });
    setColumnDefs3(colDefArr);
    setRowData3(filterData);
  };

  const setAgGrid4 = (data) => {
    let columnsArr = data[0];
    let colDefArr = [];
    let filterData = data.filter(data => data.Interface_Entity_Type === 'ALT TSDF');

    let colDef = Object.keys(columnsArr).map((col) => {
      if (customGridCells) {
        var cellRend = customGridCells.filter(
          (object) => object.columnName === col
        );
        if (cellRend.length > 0) {
          colDefArr.push({
            headerName: col.replace(/_/g, " "),
            field: col,
            maxWidth: col.includes("Interface_ID") ? 135 : "",
            sortable: true,
            cellRenderer: cellRend[0].cellRenderer,
            hide: (col.includes("Source_ID_Number") || col.includes("Entity_Type") || col.includes("Order")) ? true : false,
          });
        } else {
          colDefArr.push({
            headerName: col.replace(/_/g, " "),
            field: col,
            maxWidth: col.includes("Total_Tons") ? 105 : "",
            minWidth: col.includes("Interface_Name") ? 40 : col.includes("Interface_County") ? 12 : col.includes("Manifests") ? 20 : "",
            sortable: true,
            hide: (col.includes("Source_ID_Number") || col.includes("Entity_Type") || col.includes("Order")) ? true : false,
          });
        }
      }
    });

    setColumnDefs4(colDefArr);
    setRowData4(filterData);
  };

  const setAgGrid5 = (data) => {
    let columnsArr = data[0];
    let colDefArr = [];
    let colDef = Object.keys(columnsArr).map((col) => {
      colDefArr.push({
        headerName: col.replace(/_/g, " "),
        field: col,
        sortable: true,
      });
    });
    setColumnDefs5(colDefArr);
    setRowData5(data);
  };

  const callApi0 = async (qs, formik) => {
    axios
      .get(`${apiEndpoint0}?${qs}`, {
        cancelToken: source.token
      })
      .then((res) => {
        // setSummStop(false);
        if (res.data.length === 0) {
          setColumnDefs0([
            {
              headerName: "",
              field: "",
            },
          ]);
          setRowData0([]);

          agGridRef0.current.api.showNoRowsOverlay();
        } else {
          setAgGrid0(res.data);
          agGridRef0.current.api.hideOverlay();
        }
        setapi0IsFetching(false);
        agGridRef0.current.api.sizeColumnsToFit();
        if (
          api0IsFetching === false
        )
          formik.setSubmitting(false);
      })
      .then(async () => {
        //  setSummIsLoading(false);
      })
      .catch((err) => {
        //  setSummIsLoading(false);
        if (axios.isCancel(err)) {
          console.log("Axios Request canceled", err.message);
        } else if (err.response && err.response.status === 400) {
          let requiredFields = new Object();

          Object.keys(err.response.data).forEach((key, i) => {
            requiredFields = {
              ...requiredFields,
              [key]: err.response.data[key][0],
            };
          });

          formik.setErrors(requiredFields);
        }
        setColumnDefs0([
          {
            headerName: "",
            field: "",
          },
        ]);
        setRowData0([]);
        setapi0IsFetching(false);
        agGridRef0.current.api.showNoRowsOverlay();
        if (
          api0IsFetching === false
        )
          formik.setSubmitting(false);
      });
  };

  const callApi1 = async (qs, formik) => {
    setReportIsLoading(true); // calling the progress bar
    let value = 100;
    setapi1IsFetching(true);
    axios
      .get(`${apiEndpoint1}?${qs}`, {
        cancelToken: source.token,
        onDownloadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          if (percentCompleted > 90) {
            setReportProgressPercentage2(
              value >= 100 ? value - 1 : value++
            );
            setReportStop(true);
          }
        },
      })
      .then((res) => {
        setReportStop(false);
        if (res.data.length === 0) {
          setColumnDefs1([
            {
              headerName: "",
              field: "",
            },
          ]);
          setColumnDefs2([
            {
              headerName: "",
              field: "",
            },
          ]);
          setColumnDefs3([
            {
              headerName: "",
              field: "",
            },
          ]);
          setColumnDefs4([
            {
              headerName: "",
              field: "",
            },
          ]);
          setRowData1([]);
          agGridRef1.current.api.showNoRowsOverlay();
          agGridRef2.current.api.showNoRowsOverlay();
          agGridRef3.current.api.showNoRowsOverlay();
          agGridRef4.current.api.showNoRowsOverlay();
          agGridRef1.current.api.showNoRowsOverlay();
        } else {
          if (formRef.current.values.InterfaceType.includes('generator') === true) {
            setAgGrid1(res.data);
            agGridRef1.current.api.hideOverlay()
          };

          if (formRef.current.values.InterfaceType.includes('transporter') === true) {
            setAgGrid2(res.data)
            agGridRef2.current.api.hideOverlay()
          };

          if (formRef.current.values.InterfaceType.includes('tsdf') === true) {
            setAgGrid3(res.data)
            agGridRef3.current.api.hideOverlay()
          };

          if (formRef.current.values.InterfaceType.includes('Alternate') === true) {
            setAgGrid4(res.data)
            agGridRef4.current.api.hideOverlay()
          };
        }
        setapi1IsFetching(false);
        setHasSubmitted1(true);
        if (formRef.current.values.InterfaceType.includes('generator') === true) {
          agGridRef1.current.api.sizeColumnsToFit()
        };
        if (formRef.current.values.InterfaceType.includes('transporter') === true) {
          agGridRef2.current.api.sizeColumnsToFit()
        };
        if (formRef.current.values.InterfaceType.includes('tsdf') === true) {
          agGridRef3.current.api.sizeColumnsToFit()
        };
        if (formRef.current.values.InterfaceType.includes('AlternateDesignateFacility') === true) {
          agGridRef4.current.api.sizeColumnsToFit()
        };
        if (
          api1IsFetching === false
        )
          formik.setSubmitting(false);
      })
      .then(async () => {
        setReportIsLoading(false);
      })
      .catch((err) => {
        setReportIsLoading(false);
        if (axios.isCancel(err)) {
          console.log("Axios Request canceled", err.message);
        } else if (err.response && err.response.status === 400) {
          let requiredFields = new Object();

          Object.keys(err.response.data).forEach((key, i) => {
            requiredFields = {
              ...requiredFields,
              [key]: err.response.data[key][0],
            };
          });

          formik.setErrors(requiredFields);
        }
        setColumnDefs1([
          {
            headerName: "",
            field: "",
          },
        ]);
        setColumnDefs2([
          {
            headerName: "",
            field: "",
          },
        ]);
        setColumnDefs3([
          {
            headerName: "",
            field: "",
          },
        ]);
        setColumnDefs4([
          {
            headerName: "",
            field: "",
          },
        ]);
        setRowData1([]);
        setapi1IsFetching(false);
        setHasSubmitted1(true);
        if (formRef.current.values.InterfaceType.includes('generator') === true) {
          agGridRef1.current.api.showNoRowsOverlay();
        }
        if (formRef.current.values.InterfaceType.includes('transporter') === true) {
          agGridRef2.current.api.showNoRowsOverlay();
        }
        if (formRef.current.values.InterfaceType.includes('tsdf') === true) {
          agGridRef3.current.api.showNoRowsOverlay();
        }
        if (formRef.current.values.InterfaceType.includes('AlternateDesignateFacility') === true) {
          agGridRef4.current.api.showNoRowsOverlay();
        }
        if (
          api1IsFetching === false
        )
          formik.setSubmitting(false);
      });
  };


  const callApi2 = async (qs, formik) => {
    setapi2IsFetching(true);
    setRowData2([]);
    axios
      .get(`${apiEndpoint2}?${qs}`, {
        cancelToken: source.token,
      })
      .then((res) => {
        if (res.data.length === 0) {
          setColumnDefs5([
            {
              headerName: "",
              field: "",
            },
          ]);
          setRowData5([]);
        } else {
          setAgGrid5(res.data);
        }
        setapi2IsFetching(false);
        if (
          api0IsFetching === false &&
          api2IsFetching === false
        )
          formik.setSubmitting(false);
      })

      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log("Axios Request canceled", err.message);
        } else if (err.response && err.response.status === 400) {
          let requiredFields = new Object();

          Object.keys(err.response.data).forEach((key, i) => {
            requiredFields = {
              ...requiredFields,
              [key]: err.response.data[key][0],
            };
          });

          formik.setErrors(requiredFields);
        }
        setColumnDefs5([
          {
            headerName: "",
            field: "",
          },
        ]);
        setRowData5([]);
        setapi2IsFetching(false);
        agGridRef5.current.api.showNoRowsOverlay();
      });
  };

  const search = async (formData, formik) => {
    let obj = {};
    let myKeys = Object.keys(formData).filter((key, i) => {
      if (formData[key] !== "") {
        obj[key] = formData[key];
      }
    });

    const qs  = urlParameterHelper.stringify(obj);

    window.history.replaceState(null, 'Hazardous Waste Tracking System', `${location.pathname}?${qs}`);

    await callApi0(qs, formik);
    await callApi1(qs, formik)
    await callApi2(qs, formik);

    agGridRef0.current.api.showLoadingOverlay();
    if (formRef.current.values.InterfaceType.includes('generator') === true) {
      agGridRef1.current.api.showLoadingOverlay();
    }
    if (formRef.current.values.InterfaceType.includes('transporter') === true) {
      agGridRef2.current.api.showLoadingOverlay();
    }
    if (formRef.current.values.InterfaceType.includes('tsdf') === true) {
      agGridRef3.current.api.showLoadingOverlay();
    }
    if (formRef.current.values.InterfaceType.includes('AlternateDesignateFacility') === true) {
      agGridRef4.current.api.showLoadingOverlay();
    }
    setFormParams(formData);
  };

  const onSubmit = async (formData, formik) => {
    Object.keys(formData).map(function (key, index) {
      if (key.startsWith("multi")) {
        let object = formData[key].map((c) => c.value).join(",");
        let name = key.substr(5);
        formData[name] = object;
      }
    });
    search(formData, formik);
  };

  useEffect(() => {
    if (searchOnInit) {
      setTimeout(() => formRef.current.submitForm());
    }
  }, [searchOnInit]);

  return (
    <React.Fragment>
      <Section title="Entities Which Interface" type={"standout"} />
      <div id="page-container" className="container" style={{ position: "relative" }}>
        <Breadcrumbs
          breadcrumbs={[
            { name: "HWTS Reports", url: "/reports", active: false },
            { name: "Entities Which Interface", url: "", active: true },
          ]}
        />
        <FormikForm
          initialFormValues={initialFormValues}
          schema={schema}
          formConfig={formConfig}
          onSubmit={onSubmit}
          formRef={formRef}
          cancelCall={cancelCall}
        />
        <ProgressComponenet
          percent={reportProgressPercentage}
          setProgressPercentage={setReportProgressPercentage}
          percent2={reportProgressPercentage2}
          grid={true}
          isLoading={reportIsLoading}
          value={reportValue}
          stop={reportStop}
        />
        <br />
        {(rowData0[0]) ? (
          <div>
            <h3
              style={{
                textAlign: "center",
              }}
            >
              {formRef.current.values.epaId}- {rowData0[0].fac_name}
              <br />
            </h3>
            <h4
              style={{
                textAlign: "center",
              }}
            >
              {rowData0[0].contact_name} - {rowData0[0].contact_phone}
              <br />
              {rowData0[0].fac_str1} {rowData0[0].fac_str2}
              <br />
              {rowData0[0].fac_city} {rowData0[0].fac_st} {rowData0[0].fac_zip}
            </h4>
          </div>
        ) : null}
        <AgGridDataTable
          agGridRef={agGridRef5}
          columnDefs={columnDefs5}
          rowData={rowData5}
          initialPageSize={50}
          pageTitle="Entities Which Interface"
          formConfig={formConfig}
          formParams={formParams}
          hidePagination={true}
          csvOnly={true}
          hideRecordCnt={true}
        />
        <div>
          <h3
            style={{
              textAlign: "center",
            }}
          >
            Summary
                </h3>
          <AgGridDataTable
            agGridRef={agGridRef0}
            columnDefs={columnDefs0}
            rowData={rowData0}
            initialPageSize={50}
            pageTitle="Summary"
            formConfig={formConfig}
            formParams={formParams}
            hideCsvExport={true}
            hideRecordCnt={true}
          />
        </div>
        {(formRef.current && formRef.current.values.InterfaceType.includes('generator') === true) ? (
          <div>
            <h3
              style={{
                textAlign: "center",
              }}
            >
              Entity Interface: Generator
                </h3>
            <AgGridDataTable
              agGridRef={agGridRef1}
              columnDefs={columnDefs1}
              rowData={rowData1}
              initialPageSize={50}
              pageTitle="Generator"
              formConfig={formConfig}
              formParams={formParams}
              hideCsvExport={true}
              hideRecordCnt={true}
            />
          </div>
        ) : null}
        {(formRef.current && formRef.current.values.InterfaceType.includes('transporter') === true) ? (
          <div>
            <h3
              style={{
                textAlign: "center",
              }}
            >
              Entity Interface: Transporter
              </h3>
            <AgGridDataTable
              agGridRef={agGridRef2}
              columnDefs={columnDefs2}
              rowData={rowData2}
              initialPageSize={50}
              pageTitle="Transporter"
              formConfig={formConfig}
              formParams={formParams}
              hideCsvExport={true}
              hideRecordCnt={true}
            />
          </div>
        ) : null}
        {(formRef.current && formRef.current.values.InterfaceType.includes('tsdf') === true) ? (
          <div>
            <h3
              style={{
                textAlign: "center",
              }}
            >
              Entity Interface: TSDF
                </h3>
            <AgGridDataTable
              agGridRef={agGridRef3}
              columnDefs={columnDefs3}
              rowData={rowData3}
              initialPageSize={50}
              pageTitle="TSDF"
              formConfig={formConfig}
              formParams={formParams}
              hideCsvExport={true}
              hideRecordCnt={true}
            />
          </div>
        ) : null}

        {(formRef.current && formRef.current.values.InterfaceType.includes('AlternateDesignateFacility') === true) ? (
          <div>
            <h3
              style={{
                textAlign: "center",
              }}
            >
              Entity Interface: Alt. TSDF
                </h3>
            <AgGridDataTable
              agGridRef={agGridRef4}
              columnDefs={columnDefs4}
              rowData={rowData4}
              initialPageSize={50}
              pageTitle="AlternateDesignateFacility"
              formConfig={formConfig}
              formParams={formParams}
              hideCsvExport={true}
              hideRecordCnt={true}
            />
          </div>
        ) : null}

        <div className="m-b-md"></div>
        <TonnageDisclaimer />
      </div>
    </React.Fragment>
  );
}
